import React from "react";
import axios from "axios";
import { useState, useEffect, useContext, createContext } from "react";
import { useHistory } from "react-router-dom";
const apiKey = process.env.REACT_APP_API_KEY
export const SortByGenreContext = createContext();
var Id = "";
const SortByGenreProvider = (props) => {
  let history = useHistory();
  const [movieInfo, setMovieInfo] = useState([]);
  // const[Id, setId]= useState({})
  const getGenreList = async () => {
    try {
      const url =
        `https://api.themoviedb.org/3/genre/movie/list?api_key=${apiKey}`
      const getData = await axios.get(url);
      const list = getData.data.genres;
      console.log(getData.data.genres);
      return list;
    } catch (err) {
      history.push("/error");
      console.log(err);
    }
  };
  const getMovieDetails = async (Id) => {
    try {
      const url = `https://api.themoviedb.org/3/discover/movie?api_key=${apiKey}&with_genres=${Id}`;
      const movieData = await axios.get(url);
      console.log("movie details called");
      console.log(movieData);
      return movieData;

  
    } catch (error) {
      history.push("/error");
    }
  };
  const searchId = async (name) => {
    const getList = await getGenreList();
    for (var i = 0; i < 19; i++) {
      if (getList[i].name == name) {
        Id = getList[i].id;
        console.log(Id);
        break;
      }
    }
    const obtainedData = await getMovieDetails(Id);
    console.log(obtainedData.data.results);
    setMovieInfo(obtainedData.data.results);
  };
  return (
    <div>
      <SortByGenreContext.Provider
        value={{ movieInfo, getGenreList, Id, searchId, setMovieInfo }}
      >
        {props.children}
      </SortByGenreContext.Provider>
    </div>
  );
};
export default SortByGenreProvider;
